import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: "AIzaSyDWIERCyZzcPKwJt_-uPrcJjAZElCu89kg",
  authDomain: "kdigitale-db822.firebaseapp.com",
  projectId: "kdigitale-db822",
  storageBucket: "kdigitale-db822.firebasestorage.app",
  messagingSenderId: "682677674650",
  appId: "1:682677674650:web:87de4b3060279f1d14f523",
  measurementId: "G-5EHLB9DZE5",
  databaseURL: "https://kdigitale-db822-default-rtdb.europe-west1.firebasedatabase.app/"
}

const app = initializeApp(firebaseConfig)
export const database = getDatabase(app)
